module.exports = __webpack_public_path__ + "img/projects-2.e3312e03.jpg";